"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OAuthError = void 0;
var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _common = require("@webex/common");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Error thrown during oauth flow
 */
var OAuthError = /*#__PURE__*/function (_Exception) {
  (0, _inherits2.default)(OAuthError, _Exception);
  var _super = _createSuper(OAuthError);
  function OAuthError() {
    (0, _classCallCheck2.default)(this, OAuthError);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(OAuthError, [{
    key: "parse",
    value:
    /**
     * @param {HttpResponse} res
     * @returns {string}
     */
    function parse(res) {
      // This error may be returned in an HTTPResponse or as part of a querystring
      var body = res.body || res;
      (0, _defineProperties.default)(this, {
        error: {
          enumerable: true,
          value: body.error
        },
        errorDescription: {
          enumerable: true,
          value: body.error_description
        },
        errorUri: {
          enumerable: true,
          value: body.error_uri
        },
        res: {
          enumerable: false,
          value: res
        }
      });
      return this.errorDescription;
    }
  }]);
  return OAuthError;
}(_common.Exception);
/**
 * InvalidRequestError
 */
exports.OAuthError = OAuthError;
var InvalidRequestError = /*#__PURE__*/function (_OAuthError) {
  (0, _inherits2.default)(InvalidRequestError, _OAuthError);
  var _super2 = _createSuper(InvalidRequestError);
  function InvalidRequestError() {
    (0, _classCallCheck2.default)(this, InvalidRequestError);
    return _super2.apply(this, arguments);
  }
  return (0, _createClass2.default)(InvalidRequestError);
}(OAuthError);
/**
 * InvalidClientError
 */
var InvalidClientError = /*#__PURE__*/function (_OAuthError2) {
  (0, _inherits2.default)(InvalidClientError, _OAuthError2);
  var _super3 = _createSuper(InvalidClientError);
  function InvalidClientError() {
    (0, _classCallCheck2.default)(this, InvalidClientError);
    return _super3.apply(this, arguments);
  }
  return (0, _createClass2.default)(InvalidClientError);
}(OAuthError);
/**
 * InvalidGrantError
 */
var InvalidGrantError = /*#__PURE__*/function (_OAuthError3) {
  (0, _inherits2.default)(InvalidGrantError, _OAuthError3);
  var _super4 = _createSuper(InvalidGrantError);
  function InvalidGrantError() {
    (0, _classCallCheck2.default)(this, InvalidGrantError);
    return _super4.apply(this, arguments);
  }
  return (0, _createClass2.default)(InvalidGrantError);
}(OAuthError);
/**
 * UnauthorizedClientError
 */
var UnauthorizedClientError = /*#__PURE__*/function (_OAuthError4) {
  (0, _inherits2.default)(UnauthorizedClientError, _OAuthError4);
  var _super5 = _createSuper(UnauthorizedClientError);
  function UnauthorizedClientError() {
    (0, _classCallCheck2.default)(this, UnauthorizedClientError);
    return _super5.apply(this, arguments);
  }
  return (0, _createClass2.default)(UnauthorizedClientError);
}(OAuthError);
/**
 * UnsupportGrantTypeError
 */
var UnsupportGrantTypeError = /*#__PURE__*/function (_OAuthError5) {
  (0, _inherits2.default)(UnsupportGrantTypeError, _OAuthError5);
  var _super6 = _createSuper(UnsupportGrantTypeError);
  function UnsupportGrantTypeError() {
    (0, _classCallCheck2.default)(this, UnsupportGrantTypeError);
    return _super6.apply(this, arguments);
  }
  return (0, _createClass2.default)(UnsupportGrantTypeError);
}(OAuthError);
/**
 * InvalidScopeError
 */
var InvalidScopeError = /*#__PURE__*/function (_OAuthError6) {
  (0, _inherits2.default)(InvalidScopeError, _OAuthError6);
  var _super7 = _createSuper(InvalidScopeError);
  function InvalidScopeError() {
    (0, _classCallCheck2.default)(this, InvalidScopeError);
    return _super7.apply(this, arguments);
  }
  return (0, _createClass2.default)(InvalidScopeError);
}(OAuthError);
var errors = {
  OAuthError: OAuthError,
  InvalidRequestError: InvalidRequestError,
  InvalidClientError: InvalidClientError,
  InvalidGrantError: InvalidGrantError,
  UnauthorizedClientError: UnauthorizedClientError,
  UnsupportGrantTypeError: UnsupportGrantTypeError,
  InvalidScopeError: InvalidScopeError,
  invalid_request: InvalidRequestError,
  invalid_client: InvalidClientError,
  invalid_grant: InvalidGrantError,
  unauthorized_client: UnauthorizedClientError,
  unsupported_grant_type: UnsupportGrantTypeError,
  invalid_scope: InvalidScopeError,
  select: function select(errorString) {
    return errors[errorString] || OAuthError;
  }
};
var _default = errors;
exports.default = _default;
//# sourceMappingURL=grant-errors.js.map
